import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

import useClassName from '../../../hooks/class-name';
import { OTPWrapper } from './styled';
import MetaData from './metadata';
import Label from './label';

const OTP = (props) => {
  const [values, setValues] = useState(() => Array(props.count).fill(''));
  const inputsRef = useRef([]);
  const {
    errorMessage,
    placeholder,
    description,
    onChange,
    helpText,
    disabled,
    required,
    count,
    label,
    value,
    block,
    size,
    id
  } = props;

  const fieldWrapperClassName = useClassName([
    'field-wrapper',
    size
  ]);

  const className = useClassName([
    block ? 'block' : '',
    props.className
  ]);

  const handleChange = (e, index) => {
    const val = e.target.value.replace(/\D/, ''); // Only digits
    if (!val) return;

    const newValues = [...values];
    newValues[index] = val;

    setValues(newValues);
    onChange(e, newValues.join(''));

    if (index < count - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (values[index]) {
        const newValues = [...values];
        newValues[index] = '';
        setValues(newValues);
        onChange(e, newValues.join(''));
      }
      
      // Focus on previous field.
      if (index > 0) inputsRef.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData('Text').slice(0, count);
    const newValues = Array(count).fill('');
    if (!/\d/.test(pasted)) return;

    for (let i = 0; i < pasted.length && i < count; i++) {
      newValues[i] = pasted[i];
    }

    setValues(newValues);
    onChange(e, newValues.join(''));

    const nextIndex = Math.min(pasted.length, count - 1);
    inputsRef.current[nextIndex]?.focus();

    e.preventDefault();
  };

  useEffect(() => {
    if (value && value.length === count) {
      const values = value.split('').slice(0, count);
      setValues(values);
    }
  }, [value, count]);

  return (
    <OTPWrapper className={className}>
      <div className="main-wrapper">
        <Label description={description} required={required} label={label} id={`${id}-0`} />

        <div className={fieldWrapperClassName} onPaste={handlePaste}>
          {Array.from({ length: count }).map((_, index) => (
            <input
              ref={(el) => (inputsRef.current[index] = el)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onChange={(e) => handleChange(e, index)}
              placeholder={placeholder}
              value={values[index]}
              id={`${id}-${index}`}
              disabled={disabled}
              required={required}
              maxLength={1}
              key={index}
              type="tel"
            />
          ))}
        </div>
      </div>
      
      <MetaData errorMessage={errorMessage} helpText={helpText} />
    </OTPWrapper>
  );
};

OTP.defaultProps = {
  onChange: () => null,
  errorMessage: '',
  placeholder: '-',
  size: 'default',
  description: '',
  disabled: false,
  required: false,
  className: '',
  helpText: '',
  block: false,
  label: '',
  value: '',
  count: 6,
  id: ''
};

OTP.propTypes = {
  size: PropTypes.oneOf(['default', 'large', 'small']),
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  description: PropTypes.node,
  helpText: PropTypes.node,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  count: PropTypes.number,
  value: PropTypes.string,
  block: PropTypes.bool,
  label: PropTypes.node,
  id: PropTypes.string,
};

export default OTP;